import styled from 'styled-components';
import SummaryLegalTextTemplate from './SummaryLegalTextTemplate';
import { rem } from 'polished';

export const SummaryLegalTextStyled = styled(SummaryLegalTextTemplate)`
    margin: 0 ${rem(10)};

    p {
        padding: ${rem(16)} 0;
        margin: 0;
        font-size: ${({ theme }) => theme.fontSizes.textTiny};
        color: ${({ theme }) => theme.colors.grey16};
    }
`;
